import { GET_SHOP_OFFERS } from "../constants/endpoints";
import axiosClient from "./axios";

class shopOfferService {
  static async fetchShopOffers(
    shopId: any,
    currentPage: number,
    itemsPerPage: number,
    couponCode: string,
    offerType: string,
    isActive: boolean,
    created_at: string | null = null,
    updated_at: string | null = null
  ) {
    const url = GET_SHOP_OFFERS.replace("{shopId}", shopId);
    const filters = {
      couponCode: couponCode !== null ? couponCode : undefined,
      offerType: offerType !== null ? offerType : undefined,
      isActive: isActive !== null ? isActive : undefined,
    };
    const sort = {
      created_at: created_at !== null ? created_at : undefined,
      updated_at: updated_at !== null ? updated_at : undefined,
    };
    const response = await axiosClient.post(url, {
      page: currentPage,
      limit: itemsPerPage,
      filters: filters,
      sort: sort,
    });
    return response;
  }
}

export default shopOfferService;
